import { render, staticRenderFns } from "./AccesControlNew.vue?vue&type=template&id=949d156a&"
import script from "./AccesControlNew.vue?vue&type=script&lang=js&"
export * from "./AccesControlNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports